import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import AboutIntro from '../components/AboutIntro';
import ProcessSteps from '../components/ProcessSteps';
import AboutStats from '../components/AboutStats';
import Team from '../components/Team';
import Situations from '../components/Situations';
import Testimonials from '../components/Testimonials';
import Goal from '../components/Goal';
import Contact from '../components/Contact';
import VideoBanner from '../components/VideoBanner';
import ExpansionBanner from '../components/ExpansionBanner';
import { CTA_URL } from '../mock';
import { useI18n } from '../i18n/I18nContext';

export default function Home() {
  const location = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <main className="relative">
      <Hero />
      <ServicesGrid />

      <VideoBanner
        webm="/s1.webm" mp4="/s1.mp4"
        eyebrow={t('banner_data.eyebrow')}
        title={<>{t('banner_data.title_a')} <span className="text-gradient-green">{t('banner_data.title_b')}</span></>}
        description={t('banner_data.desc')}
        label={t('banner_data.label')}
      >
        <div className="flex flex-wrap gap-3 pt-2">
          <Link to="/services">
            <Button className="btn-primary bg-blue-500 hover:bg-blue-600 text-white rounded-xl h-11 px-5 font-medium">
              {t('nav.services')} <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </VideoBanner>

      <AboutIntro />
      <ProcessSteps />

      <VideoBanner
        webm="/s2.webm" mp4="/s2.mp4" reverse
        eyebrow={t('banner_measurable.eyebrow')}
        title={<>{t('banner_measurable.title_a')} <span className="text-gradient-green">{t('banner_measurable.title_b')}</span></>}
        description={t('banner_measurable.desc')}
        label={t('banner_measurable.label')}
      />

      <AboutStats />
      <Team />

      <VideoBanner
        webm="/s3.webm" mp4="/s3.mp4"
        eyebrow={t('banner_human.eyebrow')}
        title={<>{t('banner_human.title_a')} <span className="text-gradient-green">{t('banner_human.title_b')}</span></>}
        description={t('banner_human.desc')}
        label={t('banner_human.label')}
      >
        <div className="flex flex-wrap gap-3 pt-2">
          <a href={CTA_URL} target="_blank" rel="noreferrer">
            <Button className="btn-primary bg-blue-500 hover:bg-blue-600 text-white rounded-xl h-11 px-5 font-medium">
              {t('common.free_consultation')} <ArrowRight className="ml-1.5 h-4 w-4" />
            </Button>
          </a>
        </div>
      </VideoBanner>

      <Situations />
      <Testimonials />

      <ExpansionBanner />

      <Goal />
      <Contact />
    </main>
  );
}
